import React from 'react';
import Icon from '../../../components/AppIcon';
import TemplateCard from './TemplateCard';

const FeaturedTemplates = ({ templates, onUseTemplate }) => {
  return (
    <div className="mb-8 md:mb-12">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 bg-accent/20 rounded-lg flex items-center justify-center">
          <Icon name="Star" size={20} color="var(--color-accent)" />
        </div>
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
            Featured Templates
          </h2>
          <p className="text-sm text-muted-foreground">
            Handpicked templates for common use cases
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {templates?.map((template) => (
          <TemplateCard
            key={template?.id}
            template={template}
            onUseTemplate={onUseTemplate}
          />
        ))}
      </div>
    </div>
  );
};

export default FeaturedTemplates;